import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AccountComponent } from './account/account.component';
import { AuthGuard } from './_guards/index'; // used to prevent unauthenticated users from accessing restricted routes

const appRoutes: Routes = [
	{
		path: 'login',
		component: LoginComponent
	}, {
		path: 'dashboard',
		component: DashboardComponent,
		canActivate: [AuthGuard]
	}, {
		path: 'orders',
		loadChildren: './orders/orders.module#OrdersModule'
	}, {
		path: 'account',
		component: AccountComponent,
		canActivate: [AuthGuard]
	}, {
		path: 'account/:newuser', // If new user -- take them directly to the account page to complete registration
		component: AccountComponent,
		canActivate: [AuthGuard]
	}, {
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full'
	}
];

@NgModule({
	// Pre-load all lazy loaded feature modules (AFTER eager-loaded modules) for faster load time
	// Eliminates latency when navigating to the feature module but eager modules still load first
	imports: [RouterModule.forRoot(appRoutes, {
	  preloadingStrategy: PreloadAllModules
	})],
	exports: [RouterModule]
  })

export class AppRoutingModule { }
